import * as React from 'react';
import { useSelector } from 'react-redux';

import { AiBanner } from '../../components/AiBanner';
import { selectAiSummaryEntryPoint } from '../../selectors/newbuildingsCompare';
import { useApplicationContext } from '../../utils/applicationContext';
import { SUMMARY_ENABLED_CONFIG_KEY } from '../../constants/summary';

export const AiBannerContainer = (): React.JSX.Element | null => {
  const aiSummaryEntryPoint = useSelector(selectAiSummaryEntryPoint);
  const { config } = useApplicationContext();
  const isAiSummaryEnabled = config.get<boolean>(SUMMARY_ENABLED_CONFIG_KEY);

  if (!aiSummaryEntryPoint || !isAiSummaryEnabled) {
    return null;
  }

  return <AiBanner {...aiSummaryEntryPoint} />;
};
